const PRODUCTION_URL = 'https://nrwn8w4x0j.execute-api.us-east-1.amazonaws.com/{z}/{y}/{x}?token=';
const DEVELOPMENT_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';

function getSessionToken() {
    if (process.env.NODE_ENV !== 'production') {
        return '';
    }

    const token = sessionStorage.getItem('jwtToken');
    return token || '';
}

function getBaseUrl() {
    const accessToken = getSessionToken();
    return process.env.NODE_ENV === 'production' ? PRODUCTION_URL + accessToken : DEVELOPMENT_URL;
}

export function updateConfig() {
    const newBaseUrl = getBaseUrl();
    TILE_LAYER_CONFIG.url = newBaseUrl;
    BASE_LAYERS_CONFIG.forEach(layer => {
        layer.url = newBaseUrl;
    });
}

export const TILE_LAYER_CONFIG = {
    url: getBaseUrl(),
    attribution: 'Tiles © <a href="http://www.esri.com/" target="_blank">Esri</a>'
};

export const DEFAULT_CONFIG = {
    center: [-13.453737213419249, -55.06347656249999],
    zoom: 4,
    minZoom: 3,
    maxZoom: 17,
    doubleClickZoom: true,
    zoomControl: false,
    attributionControl: false,
    controles: {
        zoom: { enabled: true, position: 'topright' },
        fullscreen: { enabled: true, position: 'topright' },
        centralizar: { enabled: true, position: 'bottomright' },
        escala: { enabled: true, position: 'topright' }
    }
};

export const BASE_LAYERS_CONFIG = [
    {
        nome: 'Satélite',
        url: getBaseUrl(),
        attribution: 'Tiles © <a href="http://www.esri.com/" target="_blank">Esri</a>',
        maxNativeZoom: 15,
        maxZoomLevel: 17,
        urlImagem: 'basemap_satellite.png'
    }
];

function getEnvHttpPath() {
    return process.env.VUE_APP_HTTP_PATH;
}

export const URL_GEOSERVER = `${location.origin}${getEnvHttpPath()}/camadas/wms`;
export const URL_WMS_SENTINEL = `${location.origin}${getEnvHttpPath()}/camadas/sentinel/wms`;

export const DEFAULT_CONFIG_PARAGUAY = {
    center: [-23.447949, -58.452454],
    zoom: 6,
    minZoom: 3,
    maxZoom: 17,
    doubleClickZoom: true,
    zoomControl: false,
    attributionControl: false,
    controles: {
        zoom: { enabled: true, position: 'topright' },
        fullscreen: { enabled: true, position: 'topright' },
        centralizar: { enabled: true, position: 'bottomright' },
        escala: { enabled: true, position: 'topright' }
    }
};

export const DEFAULT_CONFIG_NORTH_AMERICA = {
    center: [38, -96],
    zoom: 5,
	minZoom: 3,
	maxZoom: 17,
	doubleClickZoom: true,
	zoomControl: false,
	attributionControl: false,
	controles: {
		zoom: { enabled: true, position: 'topright' },
		fullscreen: { enabled: true, position: 'topright' },
		centralizar: { enabled: true, position: 'bottomright' },
		escala: { enabled: true, position: 'topright' }
	}
};

export const DEFAULT_CONFIG_ARGENTINA = {
    center: [-40.256048, -66.031093],
    zoom: 4,
	minZoom: 3,
	maxZoom: 17,
	doubleClickZoom: true,
	zoomControl: false,
	attributionControl: false,
	controles: {
		zoom: { enabled: true, position: 'topright' },
		fullscreen: { enabled: true, position: 'topright' },
		centralizar: { enabled: true, position: 'bottomright' },
		escala: { enabled: true, position: 'topright' }
	}
};
